import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{staticClass:"grey lighten-4"},[_c('Navbar'),_c(VMain,{staticClass:"mx-4 mb-4"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }